import React from 'react';

const ChartContainer = ({ title, children, className }) => {
  return (
    <div className={`bg-gray-800 p-6 rounded-lg shadow-md mb-6 overflow-auto ${className || ''}`
    }>
      {title && (
        <h3 className="text-lg font-semibold text-white mb-4" >
          {title}
        </h3>
      )}
      <div className="w-full h-full" >
        {children}
      </div>
    </div>
  );
};

export default ChartContainer;
